import { Theme } from '@mui/material';

export const autocompleteOverrides = {
  root: ({ theme }: { theme: Theme }) => ({
    '& .MuiOutlinedInput-root': {
      padding: 0,

      '& .MuiAutocomplete-input': {
        padding: theme.spacing(1.25, 2),
      },
    },
  }),

  noOptions: {
    fontSize: 14,
  },

  option: {
    fontSize: 14,
  },
};
